import t from "../locales/";
const Header = () => {
  return <header className="header">{t("header.title")}</header>;
};

export default Header;
